import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { TextDecorator } from '@algoacademy/design-system/web/atoms/TextDecorator';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H1 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P1 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
import { FAQ } from './_svg/FAQ';
export function TopSection() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VerticalSpacer size="top" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H1>Najczęściej zadawane pytania <TextDecorator variant="gradient">(FAQ)</TextDecorator></H1>;
    t2 = <VerticalSpacer size="content" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mx-auto flex max-w-screen-sm flex-col items-center text-balance text-center">{t1}{t2}<P1>Aby ułatwić Ci dostęp do potrzebnych informacji, stworzyliśmy listę najczęściej zadawanych pytań wraz z{"\xA0"}odpowiedziami.<br />Jeśli masz inne pytania, skontaktuj się z{"\xA0"}nami - chętnie pomożemy!</P1><VerticalSpacer size="button" /><Button size="xl" href="/kontakt" className="w-full lg:w-fit">Skontaktuj się z nami</Button><VerticalSpacer size="content" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <main className="">{t0}{t3}<div className="mx-auto flex max-w-screen-sm flex-col"><FAQ /></div></main>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}